import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'summary-subtitle',
  props: {
    name: { default: '' },
    price: { default: '' },
    propClass: { default: 'text-lg' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})